(function() {
    const mainSlides1 = document.querySelectorAll('.lookbookMain1 .swiper-slide');
    const thumbSlides1 = document.querySelectorAll('.lookbookThumbnail1 .swiper-slide');

    // サムネイルスライダー
    const thumbSwiper1 = new Swiper('.lookbookThumbnail1', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        loopedSlides: thumbSlides1.length,
        slideToClickedSlide: true,
        direction: "vertical",
        
    });

    // メインスライダー
    const mainSwiper1 = new Swiper('.lookbookMain1', { 
        loop: true,
        loopedSlides: mainSlides1.length,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".lookbook-button-next1",
            prevEl: ".lookbook-button-prev1",
        },
        pagination: {
            el: ".lookbook-pagination1",
            type: "fraction",
        },
        thumbs: {
          swiper: thumbSwiper1,
        },
    });

    // メインスライダーとサムネイルスライダーの同期
    mainSwiper1.on('slideChangeTransitionEnd',()=>{
      const mainModulo1 = mainSwiper1.activeIndex%mainSlides1.length;
      const thumbModulo1 = thumbSwiper1.activeIndex%thumbSlides1.length;
      if( mainModulo1 != thumbModulo1){
        thumbSwiper1.slideToLoop(mainModulo1);
      }
    });
})();

(function() {
    const mainSlides2 = document.querySelectorAll('.lookbookMain2 .swiper-slide');
    const thumbSlides2 = document.querySelectorAll('.lookbookThumbnail2 .swiper-slide');

    // サムネイルスライダー
    const thumbSwiper2 = new Swiper('.lookbookThumbnail2', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        loopedSlides: thumbSlides2.length,
        slideToClickedSlide: true,
        direction: "vertical",
        
    });

    // メインスライダー
    const mainSwiper2 = new Swiper('.lookbookMain2', { 
        loop: true,
        loopedSlides: mainSlides2.length,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".lookbook-button-next2",
            prevEl: ".lookbook-button-prev2",
        },
        pagination: {
            el: ".lookbook-pagination2",
            type: "fraction",
        },
        thumbs: {
          swiper: thumbSwiper2,
        },
    });

    // メインスライダーとサムネイルスライダーの同期
    mainSwiper2.on('slideChangeTransitionEnd',()=>{
      const mainModulo2 = mainSwiper2.activeIndex%mainSlides2.length;
      const thumbModulo2 = thumbSwiper2.activeIndex%thumbSlides2.length;
      if( mainModulo2 != thumbModulo2){
        thumbSwiper2.slideToLoop(mainModulo2);
      }
    });
})();

(function() {
    const mainSlides3 = document.querySelectorAll('.lookbookMain3 .swiper-slide');
    const thumbSlides3 = document.querySelectorAll('.lookbookThumbnail3 .swiper-slide');

    // サムネイルスライダー
    const thumbSwiper3 = new Swiper('.lookbookThumbnail3', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        loopedSlides: thumbSlides3.length,
        slideToClickedSlide: true,
        direction: "vertical",
        
    });

    // メインスライダー
    const mainSwiper3 = new Swiper('.lookbookMain3', { 
        loop: true,
        loopedSlides: mainSlides3.length,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".lookbook-button-next3",
            prevEl: ".lookbook-button-prev3",
        },
        pagination: {
            el: ".lookbook-pagination3",
            type: "fraction",
        },
        thumbs: {
          swiper: thumbSwiper3,
        },
    });

    // メインスライダーとサムネイルスライダーの同期
    mainSwiper3.on('slideChangeTransitionEnd',()=>{
      const mainModulo3 = mainSwiper3.activeIndex%mainSlides3.length;
      const thumbModulo3 = thumbSwiper3.activeIndex%thumbSlides3.length;
      if( mainModulo3 != thumbModulo3){
        thumbSwiper3.slideToLoop(mainModulo3);
      }
    });
})();

(function() {
    const mainSlides4 = document.querySelectorAll('.lookbookMain4 .swiper-slide');
    const thumbSlides4 = document.querySelectorAll('.lookbookThumbnail4 .swiper-slide');

    // サムネイルスライダー
    const thumbSwiper4 = new Swiper('.lookbookThumbnail4', {
        slidesPerView: 'auto',
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        loopedSlides: thumbSlides4.length,
        slideToClickedSlide: true,
        direction: "vertical",
        
    });

    // メインスライダー
    const mainSwiper4 = new Swiper('.lookbookMain4', { 
        loop: true,
        loopedSlides: mainSlides4.length,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: ".lookbook-button-next4",
            prevEl: ".lookbook-button-prev4",
        },
        pagination: {
            el: ".lookbook-pagination4",
            type: "fraction",
        },
        thumbs: {
          swiper: thumbSwiper4,
        },
    });

    mainSwiper4.on('slideChangeTransitionEnd',()=>{
      const mainModulo4 = mainSwiper4.activeIndex%mainSlides4.length;
      const thumbModulo4 = thumbSwiper4.activeIndex%thumbSlides4.length;
      if( mainModulo4 != thumbModulo4){
        thumbSwiper4.slideToLoop(mainModulo4);
      }
    });
})();
